/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const CustomPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Custom Phone"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#DFD2FC"
        d="M12 12.004h.97v.97H12zm1.596 2.287h.696v-.696h-.696zm0-3.882h.696v-.696h-.696zm-3.888 0h.696v-.696h-.696zm7.759 8.771v.105a2.063 2.063 0 0 1-1.975 1.94H8.617c-1.113 0-2.025-.85-2.08-1.94V4.828a2.05 2.05 0 0 1 1.892-2.04l6.963-.01v-.007l.191.016c1.03.092 1.842.925 1.892 1.933v14.46zM9.5 4.716c0 .345.28.624.625.624h3.75a.624.624 0 1 0 0-1.25h-3.75a.624.624 0 0 0-.625.626m.554 9.233h-.97v.97h.97zm1.946 0h-.97v.97H12zm2.917-.974h-.971v-.97h-.97v-.971h-.972v.97h-.97v.97h.97v.971h.971v.97h1.946V12.97zm0-1.941V9.089H12v.966h-.97v-.966H9.082v1.945h.971v.97h-.97v.97h.97v.971h.971v-.97h-.97v-.97h.97v-.971H12v-.979h.97v.979h.976v.974h.97z"
        className="Fill-Main"
      />
      <path
        fill="#0E0E0E"
        d="M15.608 2.017 15.383 2v.008H8.617V2l-.225.017c-1.434.108-2.567 1.253-2.642 2.67V19.18c0 1.554 1.283 2.82 2.863 2.82h6.77c1.58 0 2.863-1.266 2.867-2.82V4.828c0-1.462-1.158-2.699-2.642-2.811m1.859 17.268c-.054 1.053-.904 1.886-1.975 1.94H8.617c-1.113 0-2.025-.85-2.08-1.94V4.828a2.05 2.05 0 0 1 1.892-2.04l6.963-.01v-.007l.191.016c1.03.092 1.842.925 1.892 1.933v14.565zM9.5 4.715c0-.345.28-.624.625-.624h3.75a.624.624 0 1 1 0 1.25h-3.75a.624.624 0 0 1-.625-.625m.554 7.29v.97h.971v.97h-.97v-.97h-.972v-.97zm3.888 0h-.971v-.971H12v.97h-.97v.97H12v.971h.97v.97h1.947V12.97h-.971V12zm-.971.97H12v-.97h.97zm1.32.624v.696h-.695v-.691h.696zm-3.262.35H12v.97h-.97zm3.888-3.165V9.089H12v.966h-.97v-.966H9.082v1.945h.971v.97h.971v-.97H12v-.979h.97v.979h.976v.974h.97zm-4.513-.375h-.696v-.696h.696zm3.888 0h-.696v-.696h.696zm-5.209 3.54h.971v.97h-.97z"
        className="Details"
      />
    </g>
  </svg>
);

export const CustomPhoneIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'custom-phone-icon'}
      icon={CustomPhone}
      {...props}
      size={size}
    />
  );
};
